import { Traveler } from '@marageti/z4-sdk/lib/people';
import { Actions } from '../../types';

export const SET_IS_AUTHENTICATED = 'SET_IS_AUTHENTICATED';
export const setIsAuthenticated = (isAuthenticated: boolean): Actions => ({
  type: SET_IS_AUTHENTICATED,
  isAuthenticated,
});

export const SET_GOOGLE_USER_TOKEN = 'SET_GOOGLE_USER_TOKEN';
export const setGoogleUserToken = (googleUserToken: any): Actions => ({
  type: SET_GOOGLE_USER_TOKEN,
  googleUserToken,
});

export const RESET_AUTHENTICATED_TRAVELER = 'RESET_AUTHENTICATED_TEAM_MEMBER';
export const resetAuthenticatedTraveler = (): Actions => ({
  type: RESET_AUTHENTICATED_TRAVELER,
});

export const SET_AUTHENTICATED_TRAVELER = 'SET_AUTHENTICATED_TRAVELER';
export const setAuthenticatedTraveler = (traveler: Traveler): Actions => ({
  type: SET_AUTHENTICATED_TRAVELER,
  payload: traveler,
});
